import React from "react";
import { Container, Grid, Link, Tooltip, Typography } from "@mui/material";
import styled from "@emotion/styled";
import { DataImage, PageWrapper } from "../../../Styles/style";
import heading from "../../../../assets/images/heroHeading.png";
import twitter from "../../../../assets/images/twitter.png";
import etherScan from "../../../../assets/images/etherScan.png";
import dexScreener from "../../../../assets/images/dexScreener.png";
import dextools from "../../../../assets/images/dextools.png";
import secondText from "../../../../assets/images/secondText.png";
import copy from "../../../../assets/images/copy.png";
import telegram from "../../../../assets/images/telegram.png";
import Paragraph from "../../Paragraph";
const ContinerWraper = styled(Container)`
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 !important;
`;

const GridWraper = styled(Grid)`
  width: 100%;
  position: relative;
  padding: 20px 0px 0;
  display: flex;
  align-items: center;
  justify-content: end;
  @media (max-width: 599px) {
    padding: 0;
  }
`;
const GridItem = styled(Grid)`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  @media (max-width: 599px) {
    align-items: center;
  }
`;
const ContractDiv = styled.div`
  width: 90%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 5px 10px;
  border: 2px solid;
  margin: 0 0 10px;
  @media (max-width: 599px) {
    width: 100%;
  }
`;
const Heading = styled(Typography)`
  padding: ${(props) => (props.p ? props.p : "0px")};
  margin: ${(props) => (props.m ? props.m : "0")};
  text-align: ${(props) => (props.ta ? props.ta : "left")};
  font-size: ${(props) => (props.fs ? props.fs : "46px")};
  font-family: ${(props) => (props.fm ? props.fm : "MINION")};
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 1px;
  -webkit-text-stroke: 2px #000;
  @media (max-width: 599px) {
    padding: ${(props) => props.p599};
    font-size: ${(props) => (props.fs599 ? props.fs599 : "46px")};
    text-align: center;
    line-height: 50px;
  }
`;
const HeroSection = () => {
  const [isAlertVisible, setIsAlertVisible] = React.useState(false);

  const contractAdress = "0x487e000dA8CE5Cc9914Bf33646c56A36CE247CCf";

  const handleCopy = () => {
    navigator.clipboard.writeText(contractAdress);
    setIsAlertVisible(true);
    setTimeout(() => {
      setIsAlertVisible(false);
    }, 2000);
  };
  return (
    <PageWrapper id="home">
      {isAlertVisible && (
        <div className="alert-container">
          <div style={{ transition: "1s" }} className="alert-inner">
            Contract Address Copied
          </div>
        </div>
      )}
      <ContinerWraper maxWidth="xxl">
        <Container>
          <GridWraper container>
            <GridItem item xs={12} sm={7}>
              <Heading>Smurf Predator</Heading>
              <Paragraph p="10px 0">
                In the mystical world of cryptocurrencies, there emerged a tale
                unlike any other! It all began when a group of unhinged Purple
                Smurfs, driven by their insatiable appetite for crypto riches,
                discovered the Smurf Predator token. These crazed, relentless
                predators wasted no time and aped in, ready to feast on other
                Smurf tokens in the crypto jungle. With their voracious appetite
                and unwavering determination, they embarked on a wild adventure,
                relentlessly hunting and devouring Smurf tokens, one after
                another. As they devoured their prey, their crypto dominance
                grew, and the legend of the Smurf Predators spread far and wide,
                attracting fellow crypto enthusiasts to join their thrilling
                hunt. It's a story of crypto survival of the fittest, where the
                Purple Smurfs reign supreme, and the crypto jungle has never
                been more exciting or perilous! 🌐🦁🪙🚀
              </Paragraph>
              <ContractDiv>
                <Paragraph ta599="left" color="#000" fm="BoldItalic">CA:</Paragraph>
                <div style={{display:"flex",alignItems:"center"}}>
                  <Paragraph
                    color="#000"
                    ta="right"
                    ta599="right"
                    fs599="11px"
                    fm="SemiBoldItalic"
                    sx={{ wordBreak: "break-all" }}
                  >
                    0x487e000dA8CE5Cc9914Bf33646c56A36CE247CCf
                  </Paragraph>
                  <Tooltip title="Click To Copy" placement="top">
                    <DataImage
                      onClick={handleCopy}
                      style={{ cursor: "pointer" }}
                      m="0px 0 0 5px"
                      m599="0px 0 0 5px"
                      mw="15px"
                      src={copy}
                    />
                  </Tooltip>
                </div>
              </ContractDiv>
              <div style={{ display: "flex", columnGap: "10px" }}>
                <Link href="" target="blank">
                  <DataImage mw="35px" mw599="35px" src={etherScan} />
                </Link>
                <Link href="https://www.dextools.io/app/en/ether/pair-explorer/0x487e000dA8CE5Cc9914Bf33646c56A36CE247CCf" target="blank">
                  <DataImage mw="35px" mw599="35px" src={dexScreener} />
                </Link>
                <Link
                  href=""
                  target="blank"
                >
                  <DataImage mw="35px" mw599="35px" src={dextools} />
                </Link>
                <Link href="https://twitter.com/smurfpredator" target="blank">
                  <DataImage mw="35px" mw599="35px" src={twitter} />
                </Link>
                <Link href="https://t.me/smurfpredator" target="blank">
                  <DataImage mw="35px" mw599="35px" src={telegram} />
                </Link>
              </div>
            </GridItem>
          </GridWraper>
        </Container>
      </ContinerWraper>
    </PageWrapper>
  );
};

export default HeroSection;
